import { Card, createStyles, Group } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { IconButton, ResourceIcon, Text } from '@repo/foundations';
import { buttonHoverTransition } from '@repo/theme/primitives';
import type { ColorNames } from '@repo/theme/utils';

interface BlockHeaderProps {
	onDelete: () => void;
	iconName: IconNames;
	toolTip: string;
	title: string;
	backgroundColor?: ColorNames;
	deleteDisabled?: boolean;
}

const useStyles = createStyles((theme) => ({
	section: {
		borderTop: 'none',
	},
	titleGroup: {
		backgroundColor: theme.other.getColor('surface/secondary/default'),
		'&:not(:hover) .right-component-hover': {
			opacity: 0,
		},
		'&:hover .right-component-hover': {
			opacity: 1,
			...buttonHoverTransition('opacity'),
		},
		borderTopLeftRadius: theme.radius.md,
		borderTopRightRadius: theme.radius.md,
	},
	titleGroupContent: {
		gap: theme.spacing.sm,
	},
}));

export function BlockHeader({
	onDelete,
	iconName,
	toolTip,
	title,
	backgroundColor = 'fill/secondary/default',
	deleteDisabled = false,
}: BlockHeaderProps) {
	const { classes } = useStyles();

	return (
		<Card.Section className={classes.section} withBorder>
			<Group position="apart" p="md" className={classes.titleGroup}>
				<Group className={classes.titleGroupContent}>
					<ResourceIcon iconName={iconName} backgroundColor={backgroundColor} />
					<Text size="sm" weight="semibold">
						{title}
					</Text>
				</Group>
				<IconButton
					iconName="x"
					onClick={onDelete}
					variant="tertiary"
					tooltip={toolTip}
					tooltipProps={{
						style: { maxWidth: '237px !important' },
						multiline: true,
						width: 237,
					}}
					className="right-component-hover"
					includeOffset
					disabled={deleteDisabled}
					showTooltipWhenDisabled={deleteDisabled}
				/>
			</Group>
		</Card.Section>
	);
}
